/**
 * External dependencies
 */
import React, {
	createContext,
	useState,
	useEffect,
} from 'react';

/**
 * Internal dependencies
 */
import usePrevious from '../../hooks/usePrevious';

export const HeaderContext = createContext( {
	isMenuOpen: false,
	currentOpenSubMenus: [],
	openMenu: () => {},
	closeMenu: () => {},
	openSubMenu: ( menuId ) => {},
	closeSubMenu: ( menuId ) => {},
	isSearchFormOpen: false,
	openSearchForm: () => {},
	closeSearchForm: () => {},
} );

export function HeaderProvider( { children } ) {
	const [ isMenuOpen, setMenuIsOpen ] = useState( false );
	const [ currentOpenSubMenus, setCurrentOpenSubMenus ] = useState( [] );
	const [ isSearchFormOpen, setSearchFormIsOpen ] = useState( false );

	const wasMenuOpen = usePrevious( isMenuOpen );
	const wasSearchFormOpen = usePrevious( isSearchFormOpen );

	const openMenu = () => {
		setMenuIsOpen( true );
	};

	const closeMenu = () => {
		setMenuIsOpen( false );
		setCurrentOpenSubMenus( [] );
	};

	const openSubMenu = ( menuId ) => {
		setCurrentOpenSubMenus( ( prevSubMenus ) => [ ...prevSubMenus, menuId ] );
	};

	const closeSubMenu = ( menuId ) => {
		setCurrentOpenSubMenus( ( prevSubMenus ) =>
			prevSubMenus.filter( ( id ) => id !== menuId ),
		);
	};

	const openSearchForm = () => {
		setSearchFormIsOpen( true );
	};

	const closeSearchForm = () => {
		setSearchFormIsOpen( false );
	};

	// Ensure only the menu or search form is open.
	useEffect( () => {
		if ( wasSearchFormOpen && isMenuOpen ) {
			closeSearchForm();
		} else if ( wasMenuOpen && isSearchFormOpen ) {
			closeMenu();
		}
	}, [ isMenuOpen, isSearchFormOpen, wasMenuOpen, wasSearchFormOpen ] );

	return (
		<HeaderContext.Provider value={ {
			isMenuOpen,
			currentOpenSubMenus,
			openMenu,
			closeMenu,
			openSubMenu,
			closeSubMenu,
			isSearchFormOpen,
			openSearchForm,
			closeSearchForm,
		} }>
			{ children }
		</HeaderContext.Provider>
	);
}
